import React from "react"
import { Show } from "react-admin"
import { RecordActionsTabs } from "components/ui/layouts"
import Form from "./form"

function UserShow(props: React.PropsWithChildren): JSX.Element  {

    return (
        <Show actions={<RecordActionsTabs />}>
            <Form readonly />
        </Show>
    )
}

export default UserShow
